import moment from 'moment'
import Highcharts from 'highcharts/highstock'
import More from 'highcharts/highcharts-more'
import colors from 'vuetify/es5/util/colors'
// import Exporting from 'highcharts/modules/exporting'
More(Highcharts)
// Exporting(Highcharts)
Highcharts.theme = {
  lang: {
    thousandsSep: ','
  },
  colors: [
    colors.blue.base,
    colors.green.lighten1,
    colors.red.lighten1,
    colors.purple.base
  ],
  rangeSelector: {
    inputDateFormat: '%Y-%m-%d %H:%M',
    inputEditDateFormat: '%Y-%m-%d %H:%M',
    inputDateParser (value) {
      return +moment.utc(value).toDate()
    },
    inputBoxWidth: 120,
    inputStyle: {
      backgroundColor: '#fff'
    },
    selected: 1,
    buttons: [{
      type: 'minute',
      count: 5,
      text: '5m'
    }, {
      type: 'minute',
      count: 30,
      text: '30m'
    }, {
      type: 'hour',
      count: 1,
      text: '1h'
    }, {
      type: 'hour',
      count: 4,
      text: '4h'
    }, {
      type: 'day',
      count: 1,
      text: '1d'
    }, {
      type: 'all',
      text: 'All'
    }]
  },
  yAxis: {
    // crosshair: true,
    // title: {
    //   text: 'Value'
    // },
    opposite: false
  },
  tooltip: {
    shared: true,
    split: false,
    backgroundColor: 'rgba(255, 255, 255, .85)',
    style: {
      fontSize: '13px'
    }
  },
  legend: {
    enabled: true
  },
  // navigator: {
  //   series: {
  //     color: colors.blue.base
  //   }
  // },
  credits: {
    enabled: true,
    href: 'https://dashboard.yellowsoftware.com/',
    text: '© Yellow Inc',
    position: {
      y: -2
    }
  }
}
// Apply the theme
Highcharts.setOptions(Highcharts.theme)

// Define a custom symbol path
Highcharts.SVGRenderer.prototype.symbols.cross = (x, y, w, h) => {
  return ['M', x, y, 'L', x + w, y + h, 'M', x + w, y, 'L', x, y + h, 'z']
}
if (Highcharts.VMLRenderer) {
  Highcharts.VMLRenderer.prototype.symbols.cross = Highcharts.SVGRenderer.prototype.symbols.cross
}

export default Highcharts
